<template>
    <section class="pb2-sect" :class="{ 'pb2-sect--open': open }">
        <button type="button" class="pb2-sect__head" :aria-expanded="open" @click="open = !open">
            <Icon icon="phosphor/regular/caret-down" class="pb2-sect__chev size-3" />
            <span class="pb2-sect__title">{{ title }}</span>
        </button>
        <div v-show="open" class="pb2-sect__body">
            <slot />
        </div>
    </section>
</template>

<script setup lang="ts">
/** Hairline collapsible section of the page-settings panel (redesign F3). */
defineProps<{ title: string }>();

const open = defineModel<boolean>({ default: false });
</script>

<style scoped>
.pb2-sect {
    border-top: 1px solid var(--pb2-border, #e4e4e7);
    margin: 0 -0.5rem;
    padding: 0 0.5rem;
}

.pb2-sect:first-child {
    border-top: 0;
}

.pb2-sect__head {
    display: flex;
    align-items: center;
    gap: 0.4375rem;
    width: 100%;
    min-height: 1.75rem;
    padding: 0.5rem 0.25rem;
    font-size: 0.625rem;
    line-height: 1;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--pb2-muted, #a1a1aa);
    background: none;
    border: 0;
    cursor: pointer;
    transition: color 140ms ease;
}

.pb2-sect__head:hover {
    color: var(--pb2-text, #3f3f46);
}

.pb2-sect__chev {
    flex: 0 0 auto;
    width: 0.75rem;
    height: 0.75rem;
    transition: transform 180ms ease;
    color: var(--pb2-muted, #a1a1aa);
    transform: rotate(-90deg);
}

.pb2-sect--open .pb2-sect__chev {
    transform: rotate(0deg);
}

@media (prefers-reduced-motion: reduce) {
    .pb2-sect__chev {
        transition: none;
    }
}

.pb2-sect__title {
    flex: 1;
    text-align: left;
}

.pb2-sect__body {
    padding: 0.125rem 0.25rem 0.75rem;
}
</style>
